module.exports = __webpack_public_path__ + "img/icon-image.a0e7328d.png";